export default __webpack_public_path__ + "static/ThinkstockPhotos-495145714_article-e73b714db232e6f967df24a4bb7e7742.jpg";